import React, { useState } from 'react';
import cx from 'classnames';

import { ArrowDown } from '../Icons';

type AccordionProps = {
  /**
   * The accordion content of toggle button the expand/collapse state of the accordion item.
   */
  button?: string | React.ReactNode;

  /**
   * The className to customization styling on accordion button.
   */
  buttonClassName?: string;

  /**
   * Handler expand/collapse from outer accordion
   */
  onToggle?: (isExpanded: boolean) => void;

  /**
   * Custom expand/collapse on first render
   */
  isExpanded?: boolean;

  children: React.ReactNode;

  /**
   * String value class name to customization accordion style
   */
  className?: string;
};

const Accordion: React.FC<AccordionProps> = ({
  button,
  children,
  className,
  buttonClassName,
  isExpanded: isExpandedInitially = false,
  onToggle,
}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(isExpandedInitially);

  return (
    <div className={cx('accordion', className && className)}>
      <button
        className={buttonClassName}
        onClick={() => {
          setIsExpanded(!isExpanded);
          onToggle && onToggle(!isExpanded);
        }}
      >
        {button}
        <ArrowDown
          className={cx('duration-200', { 'rotate-180': isExpanded })}
        />
      </button>
      <div
        className={cx(
          'transition-all overflow-hidden',
          isExpanded
            ? 'max-h-screen opacity-100 duration-500 ease-in'
            : 'max-h-0 opacity-80 duration-300 ease-out'
        )}
      >
        {children}
      </div>
    </div>
  );
};

Accordion.defaultProps = {
  button: '',
};

export default Accordion;
